document.addEventListener('submit', function(event) {
    if (event.target.classList.contains('variations_form') && event.target.classList.contains('cart')) {

        const formData = new FormData(event.target);
        const gtmData = {};
        const fieldsToGet = [
            'attribute_mex-e-can-5-opcional', 
            'gtm4wp_name', 'custom_activate_date', 
            'attribute_numero-de-dias-promo', 
            'attribute_numero-de-dias',
            'attribute_escolha-o-numero-de-dias',
            'attribute_plano-de-30-dias',
            'attribute_100-min-de-ligacoes-para-o-brasil-15',
            'attribute_adicionar-suica-10opcional',
            'attribute_estados-unidos-3-opcional',
            'attribute_china-ou-emirados-arabes-unidos-dubai-10opcional'
        ];
        
        // Iterar sobre os campos do formulário e obter apenas os campos desejados
        for (const pair of formData.entries()) {
            const [name, value] = pair;
            if (fieldsToGet.includes(name)) {
                gtmData[name] = value;
            }
        }

        const numberOfDays      = parseIntNumberOfDays( gtmData );
        const callsToBrazil     = gtmData['attribute_100-min-de-ligacoes-para-o-brasil-15'] === 'Sim' ? true : false;
        const optional          = defineOptional( gtmData );
        const breakUntilTheRip  = calcBreakUntilTheRip( gtmData['custom_activate_date'] );
        
        var dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'quotingPlan',
            'plan': {
                'destiny': gtmData['gtm4wp_name'],
                'numberOfDays': numberOfDays,
                'callsToBrazil': callsToBrazil,
                'optional': optional,
                'activationDate': gtmData['custom_activate_date'],
                'breakUntilTheRip': breakUntilTheRip
            }
        });
    }
});

function parseIntNumberOfDays( gtmData ) {
    let numericValue = '';

    if( gtmData['attribute_numero-de-dias-promo'] ) {
        numericValue = gtmData['attribute_numero-de-dias-promo'];
    } else if( gtmData['attribute_numero-de-dias'] ) {
        numericValue = gtmData['attribute_numero-de-dias'];
    } else if( gtmData['attribute_escolha-o-numero-de-dias'] ) {
        numericValue = gtmData['attribute_escolha-o-numero-de-dias'];
    } else if( gtmData['attribute_plano-de-30-dias'] ) {
        numericValue = gtmData['attribute_plano-de-30-dias'];
    }

    numericValue = numericValue.replace("dias", "");
    numericValue = numericValue.replace(" ", "");
    numericValue = parseInt( numericValue );

    if (isNaN(numericValue)) {
        return;
    }

    return numericValue;
}

function defineOptional( gtmData ) {
    const strTrue = 'Sim';
    if( gtmData['attribute_mex-e-can-5-opcional'] === strTrue || 
        gtmData['attribute_adicionar-suica-10opcional'] === strTrue ||
        gtmData['attribute_estados-unidos-3-opcional'] === strTrue ||
        gtmData['attribute_china-ou-emirados-arabes-unidos-dubai-10opcional'] === strTrue
    ) {
        return true;
    }

    return false;
}

function calcBreakUntilTheRip( finalDate ) {
    const currentDate = new Date();
    const [day, month, year]        = finalDate.split("/");
    const finalDateObj              = new Date(Date.UTC(year, month - 1, day, 24, 0, 0));
    const differenceInMiliseconds   = finalDateObj - currentDate;
    const oneDayInMiliseconds       = 24 * 60 * 60 * 1000;
    const differenceInDays          = Math.floor(differenceInMiliseconds / oneDayInMiliseconds);

    return differenceInDays;
}
